import { ElementType, ReactNode } from "react";

import { escape } from "he";
import { FormattedMessage } from "react-intl";

import { SanitizedHtml } from "./sanitized-html";

export type SanitizedFormattedHtmlMessageProps = {
    readonly id: string;

    readonly description?: string;
    readonly defaultMessage?: string;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    readonly values?: { [key: string]: any };
    readonly tagName?: ElementType;
};

export const SanitizedFormattedHtmlMessage = ({
    tagName,
    values,
    ...messageDescriptor
}: SanitizedFormattedHtmlMessageProps) => {
    return (
        <FormattedMessage
            tagName={tagName}
            values={escapeValues(values)}
            {...messageDescriptor}
        >
            {(html: string | InnerHTML | ReactNode[]) => {
                return <SanitizedHtml innerHTML={html} tagName={tagName} />;
            }}
        </FormattedMessage>
    );
};

function escapeValues(
    messageValues: {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        [key: string]: any | JSX.Element;
    } = {}
) {
    Object.keys(messageValues).forEach((keyName) => {
        const messageValue = messageValues[keyName];
        messageValues[keyName] =
            typeof messageValue === "string"
                ? escape(messageValue)
                : messageValue;
    });

    return messageValues;
}
